<template>
    <a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="As of"><br>
                                        <a-date-picker v-model="inputDate" format="MM-DD-YYYY" placeholder="Start Date" style="width:100%" :disabled="true"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="sortChange">>
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Display onhand">
                                        <select class="form-control" size="large" v-model="inputDisplay">
                                            <option v-for="option in displayOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select v-if="inputGroupBy == 'division_id'" class="form-control" size="large" v-model="inputSortBy" @click.prevent="autoChange">
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                        <select v-else class="form-control" size="large" v-model="inputSortExtendedBy" @click.prevent="autoChange">
                                            <option v-for="option in sortExtendedOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                                </div>
                            </div>
        
                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate per site
                            </base-checkbox>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                        {{toggleLabel}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="exportedFileName" >
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="exportedFileName" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils, {dissectReportFilters} from '../../components/reportUtils';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    import {
        mapState,
        mapActions
    } from 'vuex'
    import { getReportDescription } from '../../utilities';
    var component_x;

    export default {
        props: {
          withCost: { type: Boolean }
        },
        data() {
            return {
                spinning: false,
                inputDate: moment().startOf('day'),
                inputGroupBy: 'supplier_id',
                groupOptions: [
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'division_id', value: 'Category'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputSortBy: 'name',
                sortOptions: [
                    {key: 'name', value: 'Category'},
                    {key: 'onhand_qty', value: 'Onhand'},
                    {key: 'price', value: 'Total Price'}
                ],
                inputSortExtendedBy: 'code',
                sortExtendedOptions: [
                    {key: 'code', value: 'Supplier Code'},
                    {key: 'name', value: 'Supplier'},
                    {key: 'onhand_qty', value: 'Onhand'},
                    {key: 'price', value: 'Total Price'}
                ],
                inputDisplay: '1',
                displayOptions: [
                    {key: '1', value: 'All items regardless of onhand quantity'},
                    {key: '2', value: 'All items with onhand quantity only'},
                    {key: '3', value: 'All items with zero onhand quantity only'},
                    {key: '4', value: 'All items with negative onhand quantity only'},
                    {key: '5', value: 'All items with negative or zero onhand quantity'},
                    {key: '6', value: 'All items with positive or zero onhand quantity'},
                    {key: '6', value: 'All items except those with zero quantity'},
                ],
                isSeparateSite: false,
                birSalesReports: [],
                                
                showSortInfo: 'asc',
                JsonData: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,
                exportedFileName:"",
                stockValuationParams:{},
                accessRights:[],
                accessCostPriceRights:[],
                reportDescription: ''
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
            this.accessRights = this.$attrs.access_rights || []
            var accessCostPriceRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
            if (_.isEmpty(accessCostPriceRightsRequest.access_rights) == false){
                this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
            }else {
                this.accessCostPriceRights = []
            }
        },
        computed: {
            ...mapState(['currentProfile','endPoint', 'currentProfile']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').toString();
            },
            qtyFormatter(num){
                return Number(num).toLocaleString();
            },
            sortChange(e){
                if(e.target.value == 'brand_id'){
                    this.sortExtendedOptions[0].value = 'Brand Code'
                    this.sortExtendedOptions[1].value = 'Brand'
                } else if(e.target.value == 'supplier_id'){
                    this.sortExtendedOptions[0].value = 'Supplier Code'
                    this.sortExtendedOptions[1].value = 'Supplier'
                }
            },
            autoChange(e){
                if(this.inputGroupBy == 'division_id'){
                    this.inputSortExtendedBy = this.inputSortBy
                } else {
                    if(e.target.value == 'name' || e.target.value == 'onhand_qty' || e.target.value == 'price'){
                        this.inputSortBy = this.inputSortExtendedBy
                    } else {
                        this.inputSortBy = 'name'
                    }
                }
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            requestStockValuation: async function() {
                let additionalParams = '';
                let sorting = this.inputSortBy;

                if(this.inputGroupBy != 'division_id'){
                    sorting = this.inputSortExtendedBy
                }

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": sorting,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    "display": this.inputDisplay,
                    "advanced_filter": this.params
                }
                // bryan
                this.stockValuationParams = parameters
                if (this.withCost) {
                    parameters['with_cost'] = this.withCost;
                }
                let getRequest = await HTTPRequest.getRequest(this.endPoint + 'stock_valuation_summary?', parameters)

                return getRequest;
            },
            generateReport: async function () {
                // bryan
                this.spinning = true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Select Date');
                    return
                }

                let as_of = this.inputDate.format('MMMM DD, YYYY')
                let name_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                if(this.inputGroupBy == 'division_id'){
                    name_text = 'Division'
                }

                let get_request = await this.requestStockValuation();

                let siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    // let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    let header_detail = [];

                    if(this.inputGroupBy != 'division_id'){
                        header_detail.push({content: name_text + ' Code', styles: {halign: 'center'}})
                    }
                    header_detail.push({content: name_text, styles: {halign: 'center'}})
                    header_detail.push(
                        {content: 'On-hand\n(Pcs)', styles: {halign: 'center'}},
                        {content: 'Total Price\n(SRP)', styles: {halign: 'center'}}
                    )

                    if (this.withCost) {
                      header_detail.push(
                        {content: 'Total Original\nCost', styles: {halign: 'center'}},
                        {content: 'Total Ordering\nCost', styles: {halign: 'center'}},
                        {content: 'Total Landed\nCost', styles: {halign: 'center'}},
                      )
                    }

                    headers = [header_detail]

                    let grand_onhand_qty = 0;
                    let grand_price_x_qty = 0;
                    let grand_original_cost = 0;
                    let grand_ordering_cost = 0;
                    let grand_landed_cost = 0;

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_onhand_qty = 0;
                            let total_price_x_qty = 0;
                            let total_original_cost = 0;
                            let total_ordering_cost = 0;
                            let total_landed_cost = 0;

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let detail = []
                                if(this.inputGroupBy != 'division_id'){
                                    detail.push(reportLine.code)
                                }
                                detail.push({content: reportLine.name, styles: {halign: 'left'}},
                                    this.qtyFormatter(Number(reportLine.onhand_qty)),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.price)), 'Y')
                                )

                                total_onhand_qty += Number(reportLine.onhand_qty);
                                total_price_x_qty += Number(reportLine.price);

                                grand_onhand_qty += Number(reportLine.onhand_qty);
                                grand_price_x_qty += Number(reportLine.price);

                                if (this.withCost) {
                                  const originalCost = Number(reportLine.total_original_cost);
                                  const orderingCost = Number(reportLine.total_ordering_cost);
                                  const landedCost = Number(reportLine.total_landed_cost);

                                  detail.push(
                                    this.addMaskValidation(this.convertToCurrency(originalCost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(orderingCost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(landedCost), 'Z')
                                  )

                                  // Adding cost to per site total
                                  total_original_cost += originalCost;
                                  total_ordering_cost += orderingCost;
                                  total_landed_cost += landedCost;

                                  // Adding cost to grand total
                                  grand_original_cost += originalCost;
                                  grand_ordering_cost += orderingCost;
                                  grand_landed_cost += landedCost;
                                }

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    if(this.isSeparateSite == true){
                                        if(this.inputGroupBy != 'division_id'){
                                            sub_detail.push('')
                                        }

                                        sub_detail.push('Site Sub Total :',
                                            this.qtyFormatter(total_onhand_qty),
                                            this.addMaskValidation(this.convertToCurrency(total_price_x_qty), 'Y')
                                        )

                                        if (this.withCost) {
                                          // Sub total per site for Original, Ordering and Landed Cost
                                          sub_detail.push(
                                            this.addMaskValidation(this.convertToCurrency(total_original_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(total_ordering_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(total_landed_cost), 'Z')
                                          )
                                        }

                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))
                                    } else {
                                        //Grand Total
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        let grand_detail = []
                                        if(this.inputGroupBy != 'division_id'){
                                            grand_detail.push('')
                                        }

                                        grand_detail.push(
                                            'Grand Total :',
                                            this.qtyFormatter(grand_onhand_qty),
                                            this.addMaskValidation(this.convertToCurrency(grand_price_x_qty), 'Y')
                                        )

                                        if (this.withCost) {
                                          // Grand total for Original, Ordering and Landed Cost
                                          grand_detail.push(
                                            this.addMaskValidation(this.convertToCurrency(grand_original_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(grand_ordering_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(grand_landed_cost), 'Z')
                                          )
                                        }

                                        reportData.push(Object.assign({}, grand_detail));
                                    }
                                }
                            }
                        }

                        if(x == siteSpecific.length - 1){
                            if(this.isSeparateSite == true){
                                //Grand Total
                                reportData.push(Object.assign({}, ["rowLine"]))

                                let grand_detail = []
                                if(this.inputGroupBy != 'division_id'){
                                    grand_detail.push('')
                                }

                                grand_detail.push(
                                    'Grand Total :',
                                    this.qtyFormatter(grand_onhand_qty),
                                    this.addMaskValidation(this.convertToCurrency(grand_price_x_qty), 'Y')
                                )

                                if (this.withCost) {
                                  // Grand total for Original, Ordering and Landed Cost
                                  grand_detail.push(
                                    this.addMaskValidation(this.convertToCurrency(grand_original_cost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(grand_ordering_cost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(grand_landed_cost), 'Z')
                                  )
                                }

                                reportData.push(Object.assign({}, grand_detail));
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Stock Valuation Summary" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        // bryan
                        doc.text(15,25,"As of " + as_of)
                        if(this.isSeparateSite == true){
                            // doc.text(340,20,siteSpecific[x].report_details[0].site_name,"right");
                            doc.text(15, 30, `Site/s: ${siteSpecific[x].report_details[0].site_name}`)
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(15, 30, `Site/s: ${site_text}`)
                            // doc.text(340,20,site_text,"right");
                        }
                        let parameters = this.stockValuationParams
                        let filterText = dissectReportFilters(parameters, this.displayOptions, this.formatOptions)
                        const {basic, advance} = filterText
                        doc.text(15, 35, `Filter/s: ${basic}`)
                        if (Object.keys(parameters.advanced_filter).length !== 0) {
                            doc.text(15, 40, `Product Filter/s: ${advance}`)
                        }

                        let colStyles = {}
                        if(this.inputGroupBy == 'division_id'){
                            colStyles = {
                                0: {cellWidth: 250},
                                1: {cellWidth: 40},
                                2: {cellWidth: 40}
                            }

                            if (this.withCost) {
                              colStyles = {
                                ...colStyles,
                                0: {cellWidth: 155},
                                3: {cellWidth: 30},
                                4: {cellWidth: 30},
                                5: {cellWidth: 30},
                              }
                            }
                        } else {
                            colStyles = {
                                0: {cellWidth: 50},
                                1: {cellWidth: 200},
                                2: {cellWidth: 40},
                                3: {cellWidth: 40}
                            }

                            if (this.withCost) {
                              colStyles = {
                                ...colStyles,
                                0: {cellWidth: 40},
                                1: {cellWidth: 115},
                                4: {cellWidth: 30},
                                5: {cellWidth: 30},
                                6: {cellWidth: 30},
                              }
                            }
                        }
                        doc.autoTable({
                            // startY: 35,
                            // bryan
                            startY: Object.keys(this.params).length !== 0? 45 : 40,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            marign: {bottom: 30},
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[1] == 'Grand Total :' || data.row.raw[1] == 'Site Sub Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Stock Valuation Summary" + group_text, 340, 200, i, pageCount)
                        }
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Stock_Valuation_Summary_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error');
                }
                this.spinning = false;
            },
            generateFile: async function() {
                this.spinning = true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Select Date');
                    return
                }

                let as_of = this.inputDate.format('MMMM DD, YYYY')
                let name_text = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                if(this.inputGroupBy == 'division_id'){
                    name_text = 'Division'
                }

                let get_request = await this.requestStockValuation();

                let siteSpecific = get_request;

                if(get_request.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let header_detail = [];

                    if(this.inputGroupBy != 'division_id'){
                        header_detail.push(name_text + ' Code')
                    }
                    header_detail.push(name_text)
                    header_detail.push('On-hand (Pcs)','Total Price (SRP)')

                    if (this.withCost) {
                      header_detail.push(
                        'Total Original Cost',
                        'Total Ordering Cost',
                        'Total Landed Cost',
                      )
                    }

                    headers = header_detail

                    let grand_onhand_qty = 0;
                    let grand_price_x_qty = 0;
                    let grand_original_cost = 0;
                    let grand_ordering_cost = 0;
                    let grand_landed_cost = 0;

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_onhand_qty = 0;
                            let total_price_x_qty = 0;
                            let total_original_cost = 0;
                            let total_ordering_cost = 0;
                            let total_landed_cost = 0;

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                let detail = []
                                if(this.inputGroupBy != 'division_id'){
                                    detail.push(reportLine.code)
                                }
                                detail.push(reportLine.name,
                                    this.qtyFormatter(reportLine.onhand_qty),
                                    this.addMaskValidation(this.convertToCurrency(reportLine.price), 'Y')
                                )

                                total_onhand_qty += Number(reportLine.onhand_qty)
                                total_price_x_qty += Number(reportLine.price)

                                grand_onhand_qty += Number(reportLine.onhand_qty)
                                grand_price_x_qty += Number(reportLine.price)

                                if (this.withCost) {
                                  const originalCost = Number(reportLine.total_original_cost);
                                  const orderingCost = Number(reportLine.total_ordering_cost);
                                  const landedCost = Number(reportLine.total_landed_cost);

                                  detail.push(
                                    this.addMaskValidation(this.convertToCurrency(originalCost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(orderingCost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(landedCost), 'Z')
                                  )

                                  // Adding cost to per site total
                                  total_original_cost += originalCost;
                                  total_ordering_cost += orderingCost;
                                  total_landed_cost += landedCost;

                                  // Adding cost to grand total
                                  grand_original_cost += originalCost;
                                  grand_ordering_cost += orderingCost;
                                  grand_landed_cost += landedCost;
                                }

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    if(this.isSeparateSite == true){
                                        if(this.inputGroupBy != 'division_id'){
                                            sub_detail.push('')
                                        }

                                        sub_detail.push('Site Sub Total :',
                                            this.qtyFormatter(total_onhand_qty),
                                            this.addMaskValidation(this.convertToCurrency(total_price_x_qty), 'Y')
                                        )

                                        if (this.withCost) {
                                          // Sub total per site for Original, Ordering and Landed Cost
                                          sub_detail.push(
                                            this.addMaskValidation(this.convertToCurrency(total_original_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(total_ordering_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(total_landed_cost), 'Z')
                                          )
                                        }

                                        reportData.push(Object.assign({}, sub_detail))
                                    } else {
                                        //Grand Total
                                        let grand_detail = []
                                        if(this.inputGroupBy != 'division_id'){
                                            grand_detail.push('')
                                        }

                                        grand_detail.push(
                                            'Grand Total :',
                                            this.qtyFormatter(grand_onhand_qty),
                                            this.addMaskValidation(this.convertToCurrency(grand_price_x_qty), 'Y')
                                        )

                                        if (this.withCost) {
                                          // Grand total for Original, Ordering and Landed Cost
                                          grand_detail.push(
                                            this.addMaskValidation(this.convertToCurrency(grand_original_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(grand_ordering_cost), 'Z'),
                                            this.addMaskValidation(this.convertToCurrency(grand_landed_cost), 'Z')
                                          )
                                        }

                                        reportData.push(Object.assign({}, grand_detail));
                                    }
                                }
                            }
                        }

                        if(x == siteSpecific.length - 1){
                            if(this.isSeparateSite == true){
                                //Grand Total
                                reportData.push(Object.assign({}, ["rowLine"]))

                                let grand_detail = []
                                if(this.inputGroupBy != 'division_id'){
                                    grand_detail.push('')
                                }

                                grand_detail.push(
                                    'Grand Total :',
                                    this.qtyFormatter(grand_onhand_qty),
                                    this.addMaskValidation(this.convertToCurrency(grand_price_x_qty), 'Y')
                                )

                                if (this.withCost) {
                                  // Grand total for Original, Ordering and Landed Cost
                                  grand_detail.push(
                                    this.addMaskValidation(this.convertToCurrency(grand_original_cost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(grand_ordering_cost), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(grand_landed_cost), 'Z')
                                  )
                                }

                                reportData.push(Object.assign({}, grand_detail));
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Stock Valuation Summary" + group_text, "Generate By: " + printed_by,"as of " + as_of])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)

                        // this.JsonData = site_specific;
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                    console.log(this.JsonData)
                    let date = new Date()
                    this.exportedFileName = this.currentProfile.replace(/_/g, '-')+'-'+date.toJSON().slice(0,10).replace(/ /g, '-')
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'No Data.');
                }
                this.spinning = false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            }
        }
    };
</script>

<style></style>
